module.exports = __webpack_public_path__ + "img/f24.f0ac3673.jpg";